<template>
  <div
    class="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-gap-[20px] md:tw-justify-between tw-flex-wrap category-header"
  >
    <div
      ref="containerRef"
      data-cy="assessment-category-header"
      :class="`tw-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58] tw-capitalize animate__animated ${
        isFlashing ? ' animate__flash' : ''
      } ${className}`"
    >
      {{ title }}
    </div>
    <div
      class="tw-flex tw-flex-wrap md:tw-items-center md:tw-justify-end tw-gap-y-[15px]"
    >
      <div class="tw-flex tw-gap-[15px]">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, Ref, watch } from "vue";
const containerRef: Ref<HTMLElement | null> = ref(null);
const props = defineProps({
  /** The title of category */
  title: {
    type: String,
    default: "",
  },
  isFlashing: {
    type: Boolean,
    default: false,
  },
  className: {
    type: String,
    default: "",
  },
});

watch(props, () => {
  if (props.isFlashing) {
    setTimeout(() => {
      containerRef.value &&
        containerRef.value.classList.remove("animate__flash");
      setTimeout(() => {
        containerRef.value &&
          containerRef.value.classList.add("animate__flash");
      }, 100);
    }, 1000);
  }
});
</script>
